 $(document).ready(function() {
    // Define the mapping between title colors and app color values
    const colorMapping = {
        "bubblegum": "bubblegum",
        "blackout": "blackout",
        "bluebird": "bluebird",
        "rosaline" : "rosaline",
        "skyfall": "skyfall",
        "snowy": "snowy",
        "shortbread":"shortbread",
        "earth" : "earth",
        "starlight": "starlight",
        "graphite": "graphite",
        "raspberry": "raspberry",
        "viridian": "viridian"
    };

    // Delay to ensure app content is fully loaded
    setTimeout(function() {
        // Extract the color name from the product title's data-value
        let productTitle = $('h1.title--small').data('value').trim();
        let titleColorName = productTitle.split('|')[0].trim().toLowerCase();

        // Map the color name to the corresponding app color value
        let appColorValue = colorMapping[titleColorName];

        if (appColorValue) {
            // Trigger the click on the corresponding radio button with the mapped value
            let colorMatched = false;
            $('input.previewTextColorItem').each(function() {
                if ($(this).val().trim() === appColorValue) {
                    $(this).click(); // Trigger click on the matching radio button
                    console.log(`Clicked color: ${appColorValue}`); // Log click for debugging
                    colorMatched = true;
                    return false; // Exit the loop once a match is found
                }
            });

            // If no match is found, log the issue
            if (!colorMatched) {
                console.warn(`No matching radio button found for color: ${appColorValue}`);
            }
        } else {
            console.warn("No app color value found for title color:", titleColorName);
        }
    }, 1000); // Adjust delay as needed
});

// free gift add to cart 

// let productXId = 53798882214233; // Your X product ID
// let productYId = 54133451260249; // Your Y product ID

